export default function NotFoundPage() {
  return (
    <div className="page-content">
      <h1>404 Not Found</h1>
    </div>
  )
}